import * as o from "react";
import s from "../lib/IconBase.es.js";
import n from "../defs/CornersOut.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(s, { ref: t, ...e, weights: n }));
r.displayName = "CornersOutIcon";
const c = r;
export {
  c as CornersOut,
  r as CornersOutIcon
};
